import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SubHeaderComponent } from './sub-header.component';
import { TranslateModule } from '@ngx-translate/core';
import { DossierHeaderModule } from '../../../dossiers/components/dossierHeader.module';
import { DirectivesModule } from '../../../directives/directives.module';
import { HelpModule } from '../help/help.module';
import { MenuModule } from 'primeng-lts/menu';
import { TooltipModule } from 'primeng-lts/tooltip';


@NgModule({
  declarations: [SubHeaderComponent],
  imports: [TranslateModule,
    CommonModule,
    DossierHeaderModule,
    TooltipModule,
    HelpModule,
    MenuModule,
    //Help,
    DirectivesModule],
  // providers: [HelpModule],
  exports: [SubHeaderComponent]
})
export class SubHeaderModule { }
